import React from "react";
import styles from "./ToggleInputGroup.module.scss";

const ToggleInputGroup = ({
                              label,
                              isEnabled,
                              onToggle,
                              inputValue,
                              onInputChange,
                              placeholder,
                              disabledInput = false,
                              maxPoints,
                          }) => {
    return (
        <div
            className={`
                        justify-content-between mb-3
                        ${styles.toggleInputGroup}
                        ${label !== "Списать баллы" 
                            ? `d-flex flex-column`
                            : `d-flex`
                        }
                       `}
        >
            <div className={`form-check form-switch d-flex align-items-center ${styles.customSwitch}`}>
                <input
                    className={`form-check-input ${styles.formCheckInput}`}
                    type="checkbox"
                    id={label}
                    checked={isEnabled}
                    onChange={onToggle}
                />
                <label className={`form-check-label ms-2 ${styles.label}`} htmlFor={label}>
                    {label}
                </label>
            </div>

            {isEnabled && (
                label === "Списать баллы" ? (
                    <div className={styles.inputWrapper}>
                        <input
                            className={`form-control ${styles.input}`}
                            type="number"
                            value={inputValue}
                            onChange={onInputChange}
                            disabled={!isEnabled || disabledInput}
                            name={label}
                        />
                        <span className={styles.suffix}>/ {maxPoints}</span>
                    </div>
                ) : (
                    <input
                        className={`form-control text-center mt-2 ${styles.input} ${styles.inputLong} w-100`}
                        type="text"
                        placeholder={placeholder}
                        value={inputValue}
                        onChange={onInputChange}
                        disabled={!isEnabled || disabledInput}
                        name={label}
                    />
                )
            )}
        </div>
    );
};

export default ToggleInputGroup;
